
import { Component, Vue } from 'vue-property-decorator'
@Component
export default class UserNotifications extends Vue {
  show : boolean = false
}
